<template>
    <div class="dashboard">
        <div class="mx-0 px-0">
            <div class="row align-items-center mb-4">
                <div class="col-12 col-md-5">
                    <h1 class="main-title mb-0 title-responsive">
                        Efectos agudos y crónicos para la salud
                    </h1>
                </div>
                <div class="col-12 col-md-7">
                    <div class="row">
                        <div class="col-12 col-md-4 mb-md-0">
                            <StatsCard :value="dataDash2.total_inventory_verified" title="Productos Caracterizados" />
                        </div>
                        <div class="col-12 col-md-4 mb-md-0">
                            <StatsCard :value="fdsWithReview" title="FDS a Revisar" />
                        </div>
                        <div class="col-12 col-md-4">
                            <StatsCard :value="productNotDangerCount" title="Sin afectaciones para la salud" />
                        </div>
                    </div>
                </div>
            </div>
            <div class="dashboard-grid">
                <!-- Left Column -->
                <div class="left-column pr-md-2 pr-0" ref="leftColumn">
                    <div class="tree-section mx-0 px-0">
                        <CenterBody />
                    </div>
                </div>

                <!-- Right Column - Scrollable -->
                <div class="right-column px-0 mx-0" ref="rightColumn">
                    <div class="scrollable-content px-0 mx-0" ref="scrollableContent" :style="scrollableStyles">
                        <div class="charts-container px-0 mx-0">
                            <div class="row px-0 mx-0">
                                <div class="col-12 col-xl-6 col-md-12 mb-4 px-0 px-md-2">
                                    <ChartCard title="Toxicidad Aguda - Mortales" @chart-info-click="handleChartInfo"
                                        :showInfoButton="chartInfoButtons.acute_toxicity_mortal"
                                        chartKey="acute_toxicity_mortal" :options="categoryChartOptions"
                                        :isLoading="isLoadingChartInfo['acute_toxicity_mortal']"
                                        messageNoData="No hay productos con esta clasificación"
                                        />
                                    </div>
                                <div class="col-12 col-xl-6 col-md-12 mb-4 mb-4 px-0 px-md-2">
                                    <ChartCard title="Carcinogenicidad" @chart-info-click="handleChartInfo"
                                        :showInfoButton="chartInfoButtons.carcinogenicity" chartKey="carcinogenicity"
                                        :options="carcinogenicityChartOptions"
                                        :isLoading="isLoadingChartInfo['carcinogenicity']"
                                        messageNoData="No hay productos con esta clasificación"
                                    />
                                </div>
                                <div
                                    class="col-12 col-xl-6 col-md-12 mb-4 px-0 px-md-2"
                                    v-if="dataDash2 && dataDash2.components_priority_normative_show"
                                >
                                    <ChartCard
                                        title="Componentes de priorización normativa"
                                        @chart-info-click="handleChartInfo"
                                        :showInfoButton="
                                            chartInfoButtons.components_priority_normative
                                        "
                                        chartKey="components_priority_normative"
                                        :options="priorityChartOptions"
                                        @page-changed="handlePriorityPageChange"
                                        :isLoading="
                                            isLoadingChartInfo[
                                                'components_priority_normative'
                                            ]
                                        "
                                        messageNoData="No hay productos con esta clasificación"
                                        @chart-segment-clicked="
                                            handleSegmentClick
                                        "
                                    />
                                </div>
                                <div class="col-12 col-xl-6 col-md-12 mb-4 px-0 px-md-2">
                                    <ChartCard title="Sensibilizantes" @chart-info-click="handleChartInfo"
                                        :showInfoButton="chartInfoButtons.sensitizing" chartKey="sensitizing"
                                        :options="sensitizingChartOptions"
                                        :isLoading="isLoadingChartInfo['sensitizing']"
                                        messageNoData="No hay productos con esta clasificación"
                                        />
                                </div>
                                <div class="col-12 col-xl-6 col-md-12 mb-4 mb-4 px-0 px-md-2">
                                    <ChartCard title="Neurotóxicos" @chart-info-click="handleChartInfo"
                                        :showInfoButton="chartInfoButtons.neurotoxic" chartKey="neurotoxic"
                                        :options="neurotoxicChartOptions"
                                        :isLoading="isLoadingChartInfo['neurotoxic']"
                                        messageNoData="No hay productos con esta clasificación"
                                        />
                                </div>
                                <div class="col-12 col-xl-6 col-md-12 mb-4 mb-4 px-0 px-md-2">
                                    <ChartCard title="Toxicidad específica de órganos diana" @chart-info-click="handleChartInfo"
                                        :showInfoButton="chartInfoButtons.target_organs" chartKey="target_organs"
                                        :options="toxycityTargetOrgans"
                                        :isLoading="isLoadingChartInfo['target_organs']"
                                        messageNoData="No hay productos con esta clasificación"
                                        />
                                </div>
                                <div class="col-12 col-xl-6 col-md-12 mb-4 px-0 px-md-2">
                                    <ChartCard title="Toxicidad Aguda – Tóxicos" @chart-info-click="handleChartInfo"
                                        :showInfoButton="chartInfoButtons.toxicity_agude_toxicity" chartKey="toxicity_agude_toxicity"
                                        :options="toxycityAgude"
                                        :isLoading="isLoadingChartInfo['toxicity_agude_toxicity']"
                                        messageNoData="No hay productos con esta clasificación"
                                        />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <ProductListModal :modal-id="'products-modal'" :title="modalTitle" :products="selectedProducts"
        :keyProduct="keyProducts"
        />
        <NormativeModal :modal-id="'normative-modal'" :normative-data="normativeGroupsForModal" />
    </div>
</template>

<script>
import { mapState, mapActions, mapMutations } from "vuex";
import ChartCard from '../components/health/ChartCard.vue';
import IndicatorCard from '../components/health/IndicatorCard.vue';
import StatsCard from '../components/health/StatsCard.vue';
import CenterBody from '../components/health/CenterBody.vue';
import ProductListModal from '../components/ProductListModal.vue';
import NormativeModal from '../components/NormativeModal.vue';
import {
    getCategoryChartOptions,
    getCarcinogenicityChartOptions,
    productsChartOptions,
    healthEffectsChartOptions,
    sensitizersChartOptions,
    getReprotoxicityChartOptions,
    getOtoxicityChartOptions,
    getMutagenicityChartOptions,
    getHealthCategoriesChartOptions,
    getNeurotoxicChartOptions,
    getCorrosiveChartOptions,
    getSensitizingChartOptions,
    getAgutetoxicityChartOptions,
    getTargetOrgansChartOptions,
    getComponentForNormativeOptions
} from '../config/chartOptions';
import { validarPermisoComponente } from "../../../plugins/acl";

export default {
    name: 'Health',
    components: {
        ChartCard,
        IndicatorCard,
        StatsCard,
        CenterBody,
        ProductListModal,
        NormativeModal,
    },
    data() {
        return {
            priorityCurrentPage: 1,
            productsChartOptions,
            healthEffectsChartOptions,
            sensitizersChartOptions,
            modalTitle: '',
            selectedProducts: [],
            chartInfoButtons: {
                acute_toxicity_mortal: true,
                carcinogenicity: true,
                components_priority_normative: true,
                reprotoxicity: true,
                otoxicity: true,
                neurotoxic: true,
                corrosive: true,
                mutagenicity: true,
                sensitizing: true,
                products_by_location: false,
                target_organs: true,
                toxicity_agude_toxicity: true
            },
            isLoadingChartInfo: {},
            keyProducts: null,
            validarPermisoComponente: validarPermisoComponente,
            componentesNormative: [
                "71-43-2",
                "CAS 1487-96-6",
                "12172-73-5",
                "12001-29-5",
                "12001-28-4",
                "1332-21-4",
                "7439-92-1",
                "1317-95-9",
                "14464-46-1",
                "14808-60-7",
                "AU-167353472836952",
                "50-00-0",
                "18540-29-9"
            ],
            // Sistema de altura dinámica (copiado del primer componente)
            resizeObserver: null,
            mutationObserver: null,
            scrollableHeight: 'auto',
            resizeTimeout: null,
        };
    },
    computed: {
        ...mapState("dashboard", ["dataDash1", "dataDash2", "dashboardFilters", "productsDashAffected"]),

        componentesNormative() {
            if (!this.dataDash2 || !this.dataDash2.components_priority_normative) return [];
            return this.dataDash2.components_priority_normative.map(item => item.cas || item.key);
        },

        // Estilos computados para el contenedor scrollable
        scrollableStyles() {
            return {
                maxHeight: this.scrollableHeight,
                height: this.scrollableHeight
            };
        },

        categoryChartOptions() {
            if (!this.dataDash2 || !this.dataDash2.consulted) return {};
            return getCategoryChartOptions(this.dataDash2);
        },
        carcinogenicityChartOptions() {
            if (!this.dataDash2 || !this.dataDash2.consulted) return {};
            return getCarcinogenicityChartOptions(this.dataDash2);
        },
        priorityFullData() {
            return (this.dataDash2 && this.dataDash2.components_priority_normative) || [];
        },
        // Todos los grupos normativos del país para el modal informativo (sin filtrar por conteo)
        normativeGroupsForModal() {
            return (this.dataDash2 && this.dataDash2.component_active_for_normative) || [];
        },
        priorityChartOptions() {
            if (!this.dataDash2 || !this.dataDash2.consulted) return {};
            return getComponentForNormativeOptions(this.dataDash2);
        },
        reprotoxicityChartOptions() {
            if (!this.dataDash2 || !this.dataDash2.consulted) return {};
            return getReprotoxicityChartOptions(this.dataDash2);
        },
        otoxicityChartOptions() {
            if (!this.dataDash2 || !this.dataDash2.consulted) return {};
            return getOtoxicityChartOptions(this.dataDash2);
        },
        mutagenicityChartOptions() {
            if (!this.dataDash2 || !this.dataDash2.consulted) return {};
            return getMutagenicityChartOptions(this.dataDash2);
        },
        healthCategoriesChartOptions() {
            if (!this.dataDash2 || !this.dataDash2.consulted) return {};
            return getHealthCategoriesChartOptions(this.dataDash2);
        },
        neurotoxicChartOptions() {
            if (!this.dataDash2 || !this.dataDash2.consulted) return {};
            return getNeurotoxicChartOptions(this.dataDash2);
        },
        corrosiveChartOptions() {
            if (!this.dataDash2 || !this.dataDash2.consulted) return {};
            return getCorrosiveChartOptions(this.dataDash2);
        },
        sensitizingChartOptions() {
            if (!this.dataDash2 || !this.dataDash2.consulted) return {};
            return getSensitizingChartOptions(this.dataDash2);
        },
        fdsWithReview() {
            if (!this.dataDash2 || !this.dataDash2.consulted) return 0;
            return this.dataDash2.attachment_not_revision;
        },
        productNotDangerCount() {
            if (!this.dataDash2 || !this.dataDash2.consulted) return 0;
            return this.dataDash2.product_not_danger_count;
        },
        toxycityAgude() {
            if (!this.dataDash2 || !this.dataDash2.consulted) return {};
            return getAgutetoxicityChartOptions(this.dataDash2);
        },
        toxycityTargetOrgans() {
            if (!this.dataDash2 || !this.dataDash2.consulted) return {};
            return getTargetOrgansChartOptions(this.dataDash2);
        },
    },
    methods: {
        ...mapActions("dashboard", ["findDataProducts", "findDataProductsByCompanyAndSegment"]),
        ...mapMutations("dashboard", ["resetProductsDashAffected"]),

        handlePriorityPageChange(newPage) {
            this.priorityCurrentPage = newPage;
        },

        async handleChartInfo({ key, title }) {
            this.keyProducts = key
            this.$set(this.isLoadingChartInfo, key, true);
            this.modalTitle = title;
            this.resetProductsDashAffected();

            try {
                if (key === "components_priority_normative") {
                    this.$bvModal.show("normative-modal");
                } else {
                    const filters = {
                        ...this.dashboardFilters,
                        affectation: key,
                    };
                    await this.findDataProducts(filters);
                    this.selectedProducts = this.productsDashAffected;
                    this.$bvModal.show("products-modal");
                }
            } catch (error) {
                console.error("Error al cargar los productos:", error);
            } finally {
                this.$set(this.isLoadingChartInfo, key, false);
            }
        },

        async handleSegmentClick(data) {
            this.keyProducts = (data.key ? data.key : data.cas) || "";

            let isLoadNormative = '';
            if (this.componentesNormative.includes(this.keyProducts)) {
                isLoadNormative = 'components_priority_normative';
            }

            this.$set(this.isLoadingChartInfo, isLoadNormative, true);
            this.modalTitle = (data.title ? data.title : "PQ CON COMPONENTE "+data.name) || "";
            this.resetProductsDashAffected();

            try {
                const filters = {
                    ...this.dashboardFilters,
                    segment: this.keyProducts || (data.key ? data.key : data.cas),
                };
                await this.findDataProductsByCompanyAndSegment(filters);
                this.selectedProducts = this.productsDashAffected;
                this.$bvModal.show("products-modal");
            } catch (error) {
                console.error("Error al cargar los productos:", error);
            } finally {
                this.$set(this.isLoadingChartInfo, isLoadNormative, false);
            }
        },

        // ========= MÉTODOS DE ALTURA DINÁMICA (COPIADOS DEL PRIMER COMPONENTE) =========

        // Método principal para calcular la altura
        calculateScrollableHeight() {
            // Limpiar timeout anterior si existe
            if (this.resizeTimeout) {
                clearTimeout(this.resizeTimeout);
            }

            // Debounce para evitar cálculos excesivos
            this.resizeTimeout = setTimeout(() => {
                this.updateScrollableHeight();
            }, 50);
        },

        // Actualizar altura del contenedor scrollable
        updateScrollableHeight() {
            // Solo aplicar en pantallas grandes (desktop)
            if (window.innerWidth <= 991) {
                this.scrollableHeight = 'auto';
                return;
            }

            this.$nextTick(() => {
                const leftColumn = this.$refs.leftColumn;

                if (!leftColumn) {
                    this.scrollableHeight = 'auto';
                    return;
                }

                // Obtener altura real del contenido de la columna izquierda
                const leftHeight = leftColumn.scrollHeight;

                // Aplicar la altura calculada
                this.scrollableHeight = `${leftHeight}px`;
            });
        },

        // Configurar observadores
        setupObservers() {
            // ResizeObserver para cambios de tamaño
            if ('ResizeObserver' in window) {
                this.resizeObserver = new ResizeObserver(() => {
                    this.calculateScrollableHeight();
                });

                // Observar la columna izquierda
                if (this.$refs.leftColumn) {
                    this.resizeObserver.observe(this.$refs.leftColumn);
                }

                // Observar el documento completo para cambios de zoom
                this.resizeObserver.observe(document.documentElement);
            }

            // MutationObserver para cambios en el DOM
            if ('MutationObserver' in window) {
                this.mutationObserver = new MutationObserver(() => {
                    this.calculateScrollableHeight();
                });

                if (this.$refs.leftColumn) {
                    this.mutationObserver.observe(this.$refs.leftColumn, {
                        childList: true,
                        subtree: true,
                        attributes: true,
                        attributeFilter: ['style', 'class']
                    });
                }
            }
        },

        // Limpiar observadores
        cleanupObservers() {
            if (this.resizeObserver) {
                this.resizeObserver.disconnect();
                this.resizeObserver = null;
            }

            if (this.mutationObserver) {
                this.mutationObserver.disconnect();
                this.mutationObserver = null;
            }

            if (this.resizeTimeout) {
                clearTimeout(this.resizeTimeout);
                this.resizeTimeout = null;
            }
        }
    },

    mounted() {
        // Configurar observadores
        this.setupObservers();

        // Cálculo inicial
        this.$nextTick(() => {
            this.calculateScrollableHeight();
        });

        // Event listener para resize de ventana (backup)
        window.addEventListener('resize', this.calculateScrollableHeight);

        // Event listener para cambios de zoom
        window.addEventListener('orientationchange', this.calculateScrollableHeight);
    },

    updated() {
        // Recalcular cuando el componente se actualiza
        this.$nextTick(() => {
            this.calculateScrollableHeight();
        });
    },

    beforeDestroy() {
        // Limpiar event listeners
        window.removeEventListener('resize', this.calculateScrollableHeight);
        window.removeEventListener('orientationchange', this.calculateScrollableHeight);

        // Limpiar observadores
        this.cleanupObservers();
    }
};
</script>

<style scoped>
.dashboard {
    background-color: #00000000;
}

.main-title {
    position: relative;
    margin-bottom: 0;
    font-size: 2.2rem;
    font-weight: 800;
    color: #1B212E;
    z-index: 1;
}

.right-column {
    display: flex;
    flex-direction: column;
    min-height: 0;
}

.scrollable-content {
    overflow-y: auto;
    overflow-x: hidden;
    flex: 1;
    /* Scroll suave */
    scroll-behavior: smooth;
    /* Estilos de scrollbar personalizados */
    scrollbar-width: thin;
    scrollbar-color: #0fbef96a transparent;
}

.scrollable-content::-webkit-scrollbar {
    width: 2px;
}

.scrollable-content::-webkit-scrollbar-track {
    background: transparent;
}

.scrollable-content::-webkit-scrollbar-thumb {
    background-color: #0fbef96a;
    border-radius: 1px;
}

.scrollable-content::-webkit-scrollbar-thumb:hover {
    background-color: #0fbef96a;
}

.title-responsive {
    font-size: 2.2rem;
}

@media (max-width: 1850px) {
    .title-responsive {
        font-size: 2rem;
    }
}

@media (max-width: 1155px) {
    .title-responsive {
        font-size: 1.8rem;
    }
}

@media (max-width: 900px) {
    .title-responsive {
        font-size: 1.5rem;
    }
}

@media (max-width: 700px) {
    .title-responsive {
        font-size: 1.3rem;
    }
}

@media (max-width: 600px) {
    .title-responsive {
        font-size: 1.2rem;
    }
}

/* ========= ESTILOS DE ALTURA DINÁMICA (COPIADOS DEL PRIMER COMPONENTE) ========= */

/* Grid principal mejorado */
.dashboard-grid {
    display: grid;
    grid-template-columns: 1.5fr 1.5fr;
    gap: 0 24px;
    align-items: start; /* Cambiado de stretch a start */
    min-height: 80vh;
}

.left-column, .right-column {
    min-width: 0;
    display: flex;
    flex-direction: column;
}

.left-column {
    /* Altura natural del contenido */
    height: fit-content;
}

.right-column {
    /* Altura fija para mantener sincronización */
    height: 80vh;
}

/* Responsive: En mobile volver al comportamiento normal */
@media (max-width: 1450px) {
    .dashboard-grid {
        display: block;
        min-height: unset;
    }

    .left-column, .right-column {
        height: auto;
    }

    .scrollable-content {
        max-height: none !important;
        height: auto !important;
        overflow-y: visible;
    }
}

/* Mejorar la transición cuando cambia la altura */
.scrollable-content {
    transition: max-height 0.2s ease-out;
}
</style>
